import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import SmoothScroll from '@/components/landing/smooth-scroll'
import Preloader from '@/components/landing/preloader'
import SiteHeader from '@/components/landing/site-header'
import MenuOverlay from '@/components/landing/menu-overlay'
import SectionCounter from '@/components/landing/section-counter'
import CustomCursor from '@/components/landing/custom-cursor'
import BlueprintGrid from '@/components/landing/blueprint-grid'
import HeroSection from '@/components/landing/hero-section'
import PromiseSection from '@/components/landing/promise-section'
import GearSection from '@/components/landing/gear-section'
import NumbersSection from '@/components/landing/numbers-section'
import SolutionsSection from '@/components/landing/solutions-section'
import CapabilitiesSection from '@/components/landing/capabilities-section'
import ControllerSection from '@/components/landing/controller-section'
import SoftwareSection from '@/components/landing/software-section'
import TerrainSection from '@/components/landing/terrain-section'
import SiteFooter from '@/components/landing/site-footer'
import RequestDialog from '@/components/landing/request-dialog'

const DroneCanvas = dynamic(() => import('@/components/landing/drone-canvas'), { ssr: false })

const Home: FC = (): ReactNode => {
    return (
        <Layout
            header={(
                <>
                    <SmoothScroll />
                    <Preloader />
                    <BlueprintGrid />
                    <DroneCanvas />
                    <SiteHeader />
                    <MenuOverlay />
                    <SectionCounter />
                    <CustomCursor />
                </>
            )}
            footer={(
                <>
                    <SiteFooter />
                    <RequestDialog />
                </>
            )}
        >
            <Seo />

            <HeroSection />
            <PromiseSection />
            <GearSection />
            <NumbersSection />
            <SolutionsSection />
            <CapabilitiesSection />
            <ControllerSection />
            <SoftwareSection />
            <TerrainSection />
        </Layout>
    )
}

export default Home
